import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { NotFound } from "./NotFound";
import { PageSkeleton } from "../components/PageSkeleton";
import { BreadcrumpComponent } from "../components/subcomponents/BreadcrumpCompont";
import { apiGet } from "../utils/api";
import { Colors } from "../utils/utils.colors";
import { routes } from "../utils/utils.routes";
import bigCover from '../assets/images/big-cover.jpg';

export const PartnerDetail: React.FC = () => {
  const { slug } = useParams();
  const [partner, setPartner] = useState<any | null>(undefined as any);

  useEffect(() => {
    if (!slug) return;
    apiGet(`/partners/slug/${slug}`)
      .then((d) => setPartner(d.item))
      .catch(() => setPartner(null));
  }, [slug]);

  if (partner === undefined) return <PageSkeleton />;
  if (partner === null) return <NotFound />;

  return (
    <>
      <BreadcrumpComponent
        title={partner.name}
        subtitle="Détails du partenaire"
        imageCover={bigCover}
      />

      <div className="padding-x site-content" style={{ paddingTop: '3rem', paddingBottom: '4rem' }}>
        <main className="wp-block-group alignfull has-global-padding is-layout-constrained wp-block-group-is-layout-constrained">
          <Link
            to={routes.PARTNERS}
            style={{
              display: 'inline-flex', alignItems: 'center', gap: 6,
              fontSize: 14, color: Colors.primaryColor, fontWeight: 600,
              textDecoration: 'none', marginBottom: '1.5rem',
            }}
          >
            ← Retour aux partenaires
          </Link>

          <div style={{
            display: 'flex', gap: '2rem', alignItems: 'flex-start',
            background: '#fff', borderRadius: 16, padding: '3rem',
            boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
            flexWrap: 'wrap',
          }}>
            <div style={{
              flexShrink: 0, width: 140, height: 140, borderRadius: '50%',
              background: Colors.primaryColor, display: 'flex',
              alignItems: 'center', justifyContent: 'center',
              color: '#fff', fontSize: 48, fontWeight: 700,
            }}>
              {partner.logo ? (
                <img src={partner.logo} alt={partner.name} style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} />
              ) : (
                partner.name.charAt(0)
              )}
            </div>

            <div style={{ flex: 1, minWidth: 240 }}>
              <h1 style={{ fontSize: 28, fontWeight: 800, color: '#222', margin: '0 0 0.5rem' }}>{partner.name}</h1>
              {partner.description && (
                <p style={{ fontSize: 15, color: '#555', lineHeight: 1.7, margin: '0 0 1.5rem' }}>{partner.description}</p>
              )}
              {partner.url && (
                <a
                  href={partner.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex', alignItems: 'center', gap: 8,
                    padding: '10px 24px', borderRadius: 8,
                    background: Colors.primaryColor, color: '#fff',
                    fontSize: 14, fontWeight: 600, textDecoration: 'none',
                  }}
                >
                  Visiter le site web →
                </a>
              )}
            </div>
          </div>
        </main>
      </div>
    </>
  );
};
